export default __webpack_public_path__ + "static/media/kitchen3-afterC-2048w.9595a7ff.png";